import {
  ModalOpenContext,
  ModalOpenContextBuilder,
  FluentAssignMethod,
  privateKey,
  extend,
  arrayUnion
} from 'angular2-modal';


const /** @type {?} */ DEFAULT_VALUES = {
  className: /** @type {?} */(( <VEXBuiltInThemes>'default')),
  overlayClassName: 'vex-overlay',
  contentClassName: 'vex-content',
  closeClassName: 'vex-close'
};

const /** @type {?} */ DEFAULT_SETTERS = [
  'className',
  'overlayClassName',
  'contentClassName',
  'closeClassName',
  'showCloseButton'
];

export type VEXBuiltInThemes
  = 'default' | 'os' | 'plain' | 'wireframe' | 'flat-attack' | 'top' | 'bottom-right-corner';
export class VEXModalContext extends ModalOpenContext {
/**
 * Set the built in schema to use.
 */
className: VEXBuiltInThemes;

  overlayClassName: string;
  contentClassName: string;
  closeClassName: string;

  showCloseButton: boolean;
/**
 * @return {?}
 */
normalize(): void {
    if (!this.className) {
      this.className = DEFAULT_VALUES.className;
    }

    if (!this.overlayClassName) {
      this.overlayClassName = DEFAULT_VALUES.overlayClassName;
    }

    if (!this.contentClassName) {
      this.contentClassName = DEFAULT_VALUES.contentClassName;
    }

    if (!this.closeClassName) {
      this.closeClassName = DEFAULT_VALUES.closeClassName;
    }

    super.normalize();
  }
}

function VEXModalContext_tsickle_Closure_declarations() {
/**
 * Set the built in schema to use.
 * @type {?}
 */
VEXModalContext.prototype.className;
/** @type {?} */
VEXModalContext.prototype.overlayClassName;
/** @type {?} */
VEXModalContext.prototype.contentClassName;
/** @type {?} */
VEXModalContext.prototype.closeClassName;
/** @type {?} */
VEXModalContext.prototype.showCloseButton;
}

export class VEXModalContextBuilder<T extends VEXModalContext> extends ModalOpenContextBuilder<T> {
/**
 * Set the built in schema to use.
 */
className: FluentAssignMethod<VEXBuiltInThemes, this>;

  overlayClassName: FluentAssignMethod<string, this>;
  contentClassName: FluentAssignMethod<string, this>;
  closeClassName: FluentAssignMethod<string, this>;

  showCloseButton: FluentAssignMethod<boolean, this>;
/**
 * @param {?=} defaultValues
 * @param {?=} initialSetters
 * @param {?=} baseType
 */
constructor(defaultValues: T = undefined,
              initialSetters: string[] = undefined,
              baseType: new () => T = undefined) {
    super(
      extend<any>(DEFAULT_VALUES, defaultValues || {}),
      arrayUnion<string>(DEFAULT_SETTERS, initialSetters || []),
      baseType || <any>VEXModalContext // https://github.com/Microsoft/TypeScript/issues/7234
    );
  }
/**
 *
 * \@aliasFor isBlocking
 * @param {?} value
 * @return {?}
 */
overlayClosesOnClick(value: boolean): this {
    this[privateKey('isBlocking')] = !value;
    return this;
  }
}

function VEXModalContextBuilder_tsickle_Closure_declarations() {
/**
 * Set the built in schema to use.
 * @type {?}
 */
VEXModalContextBuilder.prototype.className;
/** @type {?} */
VEXModalContextBuilder.prototype.overlayClassName;
/** @type {?} */
VEXModalContextBuilder.prototype.contentClassName;
/** @type {?} */
VEXModalContextBuilder.prototype.closeClassName;
/** @type {?} */
VEXModalContextBuilder.prototype.showCloseButton;
}

